interface PaymentSummary {
  attemptNumber: number;
  firstPaymentAttempt: string;
  lastPaymentAttempt: string;
}

interface ContractSummary {
  contractNumber: string;
  status: string;
  startDate: string;
  endDate: string;
}

interface CustomerSummary {
  name: string;
  rut: string;
  type: string;
  mail: string;
  phoneNumber: string;
  address: string;
  country: string;
}

enum CaseContract {
  UNCOLLECTIBLE = 'INCOBRABLE',
  CRITICAL = 'CRITICO',
  MODERATE = 'MEDIO',
  LOW = 'BAJO'
}

interface RentSummary {
  sku: string;
  store: number;
  channel: number;
  rentAmount: string;
  warrantyAmount: string;
  toolName: string;
  rentPaymentMethod: string;
  warrantyPaymentMethod: string;
  cases: CaseContract;
}


export interface Contract {
  isShowingDetail: boolean
  payment: PaymentSummary;
  contract: ContractSummary;
  customer: CustomerSummary;
  rent: RentSummary;
}

export enum ExcelStatus {
  FAILED = 'failed',
  SUCCESSFUL = 'successful',
  UNTRIGGED = 'untrigged'
}


export interface Recovery {
  total: number;
  contracts: Contract[];
  excelStatus: ExcelStatus;
  selectors: {
    centers: any[], // TO-DO: Interface
    cases: any[], // TO-DO: Interface
  };
  autoPayCases: Record<string, Omit<AutoPayCase, 'name'>>;
  error?: string;
}


export interface Warranty {
  recovery: Recovery;
}


export interface AutoPayCase {
  name: string;
  amountMin?: string;
  amountMax?: string;
  attemptsMin?: string;
  attemptsMax?: string;
  colorRGB: string;
}

